import React from 'react';
import PropTypes from 'prop-types';
import ChevronRight from '@images/svg/ui/chevron-right.svg';
import { Link } from 'react-router-dom';

const Button = ({ label, onClick, to }) => {
  const commonProps = {
    className: 'c-button',
    onClick: onClick || null
  };

  const content = (
    <>
      <span className='c-button__label'>{label}</span>
      <span className='c-button__icon'>
        <ChevronRight />
      </span>
    </>
  );

  return to ? (
    <Link to={to} {...commonProps}>
      {content}
    </Link>
  ) : (
    <button {...commonProps}>{content}</button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string
};

export default Button;
